import * as types from './mutation-types';
import EventBus from '@/utils/eventBus';
import customerService from '@/services/customer';

export const getCustomer = ({
  commit,
  state,
}, filter) => {
  EventBus.$emit('show-loading', true);

  if (!filter && (state.lastFilter)) {
    filter = state.lastFilter;
  }

  customerService.countAll((err, i) => {
    customerService.get(filter, (e, res) => {
      EventBus.$emit('show-loading', false);
      commit(types.GET_CUSTOMER, {
        lastFilter: filter,
        customers: res.data,
        count: i.data.count,
      });
    });
  });
};

export default {
  getCustomer,
};



// WEBPACK FOOTER //
// ./src/store/modules/customer/actions.js